<div>
  <div class="process_data flex gap-2">
    <div class="process_data_text" i18n>
      {{ 'Receitas a processar' | translate}}: {{prescriptionUnprocessedCount}}
    </div>
    <div class="process_data_text" i18n>
      {{ 'Receitas integradas' | translate}}: {{prescriptionIntegratedCount}}
    </div>
    <div class="process_data_text" i18n>
      {{ 'Receitas revisadas' | translate}}: {{prescriptionReviewedCount}}
    </div>
  </div>
  <div class="process_data flex gap-2">
    <div class="process_data_text" i18n>
      {{ 'Receitas revisadas hoje' | translate}}: {{prescriptionReviewedTodayCount}}
    </div>
    <div class="process_data_text" i18n>
      {{ 'Receitas revisadas no grupo hoje' | translate}}: {{prescriptionReviewedGroupCount}}
    </div>
  </div>
</div>